"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _RecentActivityHeaderFormComponent = _interopRequireDefault(require("./RecentActivityHeaderFormComponent"));
var _paginationActions = require("../../../../redux/actions/paginationActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var formValue = (0, _reduxForm.formValueSelector)('recent-activity');
  return {
    endDate: formValue(state, 'endDate')
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setEndDate: function setEndDate(value) {
      return dispatch((0, _reduxForm.change)('recent-activity', 'endDate', value));
    },
    clearFilters: function clearFilters() {
      dispatch((0, _reduxForm.change)('recent-activity', 'startDate', null));
      dispatch((0, _reduxForm.change)('recent-activity', 'endDate', null));
      dispatch((0, _reduxForm.change)('recent-activity', 'type', 'all'));
    },
    resetActivePage: function resetActivePage() {
      return dispatch((0, _paginationActions.setActivePage)({
        componentName: 'RecentActivityComponent',
        activePage: 0
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_RecentActivityHeaderFormComponent["default"]);